import { CancellationToken, IFrameContext } from "@multiweb/types/multiweb";
import { AnyConstructor } from "Global/Base/types";
import { RequestContext } from "OW.Remoting/Remoting/RequestContext";
import { convertContextFromFrameToRequest } from "UI/UI/Utilities/SharedUIMethods";
import { IControl, IHasFrameContext } from "./ControlInterfaces";

/** Mixin pro komponenty pracující s frame kontextem
 * Nesmí se aplikovat na komponenty, které už mají nějakou logiku pro získání `frameContext`. V takovém případě by ji nahradil za propertu bez getteru/setteru.
*/
export const HasFrameContextMixin = <T extends AnyConstructor<IControl>>(Base: T) =>
    class HasFrameContext extends Base implements IHasFrameContext {
        public frameContext: IFrameContext | undefined = undefined;
        public _getRequestContext(cancellationToken: CancellationToken = CancellationToken.none): RequestContext {
            return convertContextFromFrameToRequest(this.frameContext, cancellationToken);
        }
    };
